import { CheckoutFormValues } from '../../types/appointments';
import { formatDollarAmount } from '../global/helper';

type CartLine = NonNullable<CheckoutFormValues['customOrderItems']>[number];

/** A search like `25` or `$1,250.50` reads as an amount; anything else is a name. */
export function customAmount(query: string): number | null {
  const amount = Number(query.trim().replace(/[$,]/g, ''));
  return query.trim() && Number.isFinite(amount) && amount > 0 ? amount : null;
}

export function customLineLabel(query: string) {
  const amount = customAmount(query);
  if (amount !== null) return `Add ${formatDollarAmount(amount)} custom amount`;
  const name = query.trim();
  return name ? `Add custom item "${name}"` : 'Add custom item';
}

/** A cart line that is not in the item library, priced in checkout unless typed as an amount. */
export function customLine(query: string, id: string): CartLine {
  const amount = customAmount(query);
  if (amount !== null) {
    return { id, name: 'Custom Amount', quantity: 1, price: amount };
  }
  return { id, name: query.trim() || 'Custom Item', quantity: 1, price: 0 };
}
